import { css } from '@emotion/react';

import { media } from '../shared/styles';

export const cardContainerStyles = (
  orientation: 'vertical' | 'horizontal',
  hasContentBackground: boolean,
  hasClickHandler: boolean,
  background = 'white'
) => css`
  ${hasClickHandler &&
  `
    cursor: pointer;
  `}

  color: var(--text-primary);
  position: relative;
  width: 100%;
  height: 100%;
  background: ${background};
  overflow: hidden;
  transition: all 0.2s ease;

  /* Force vertical layout on mobile */
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);

  ${orientation === 'horizontal' &&
  css`
    /* Apply horizontal layout only on tablet and up */
    ${media.md} {
      flex-direction: row;
      gap: var(--spacing-4);
      box-shadow: 0 0 var(--shadow-blur-lg, 24px) var(--shadow-spread-xs, -4px)
        rgba(17, 17, 17, 0.1);

      ${hasClickHandler &&
      `
        &:hover {
          box-shadow: 0 5px 30px 0 rgba(0,0,0,.1);
        }
      `}
    }
  `}

  ${hasContentBackground
    ? `
    border-radius: var(--spacing-4);
  `
    : `
    border-radius: var(--spacing-4) var(--spacing-4) 0 0;
  `}

  ${orientation === 'horizontal' &&
  `
    ${media.md} {
      border-radius: var(--spacing-4);
    }
  `}
`;

export const imageContainerStyles = (
  orientation: 'vertical' | 'horizontal',
  imageHeight = '260px',
  horizontalImageHeight = '200px'
) => css`
  width: 100%;
  height: ${imageHeight};

  ${orientation === 'horizontal' &&
  css`
    ${media.md} {
      width: 40%;
      height: ${horizontalImageHeight};
    }
  `}
`;

export const imageBoxStyles = (
  orientation: 'vertical' | 'horizontal',
  imageHeight = '260px',
  horizontalImageHeight = '200px'
) => css`
  height: ${imageHeight};
  ${orientation === 'horizontal' &&
  css`
    ${media.md} {
      height: ${horizontalImageHeight};
    }
  `}
`;

export const contentContainerStyles = (
  orientation: 'vertical' | 'horizontal',
  hasContentBackground: boolean
) => css`
  ${hasContentBackground
    ? contentWithBackgroundStyles
    : contentWithoutBackgroundStyles}
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${orientation === 'horizontal' &&
  css`
    ${media.md} {
      width: 60%;
      justify-content: center;
    }
  `}
`;

export const imageStyles = css`
  position: relative;
  background-color: lightgray;
`;

export const imageGradientStyles = css`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    181deg,
    rgba(0, 0, 0, 0) 75.32%,
    rgba(0, 0, 0, 0.4) 99.41%
  );
`;

export const badgeTopLeftStyles = css`
  position: absolute;
  top: var(--spacing-3);
  left: var(--spacing-3);
  z-index: 2;
`;

export const badgeBottomRightStyles = css`
  position: absolute;
  bottom: var(--spacing-3);
  right: var(--spacing-3);
  z-index: 2;
`;

export const heartIconStyles = css`
  position: absolute;
  top: var(--spacing-3);
  right: var(--spacing-3);
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  border: 1px solid var(--border-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
`;

export const actionMenuStyles = css`
  position: absolute;
  top: var(--spacing-3);
  right: var(--spacing-3);
  z-index: 3;
`;

export const contentWithBackgroundStyles = css`
  padding: 0 var(--spacing-3) var(--spacing-4) var(--spacing-3);
  background-color: var(--surface-page);
`;

export const contentWithoutBackgroundStyles = css`
  padding: 0;
`;

export const overlayStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
  border-radius: var(--spacing-4);
  display: block;
  pointer-events: none;
`;

export const titleStyles = css`
  text-wrap: wrap;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;
